import { CUISINE_FILTER_METROS } from 'components/www/availability-search/SearchBarDesktop';

import {
  ACTION_CUISINE_FILTER_APPLIED,
  CATEGORY_CITYWIDE_SEARCH,
} from 'utils/analytics/eventTypesConstants';
import { useCurrentMetroArea } from 'hooks/useCurrentMetroArea';
import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';

/**
 * Shared functionality for cuisine filters
 */
export const useCuisineFilters = () => {
  const currentMetroArea = useCurrentMetroArea();
  const cuisineFiltersEnabled =
    useFeatureFlagForConsumer('CUISINE_SEARCH_FILTER') &&
    CUISINE_FILTER_METROS.has(currentMetroArea?.name || '');

  const sendCuisineGAEvents = (selectedCuisines: string[]) => {
    selectedCuisines.forEach((selectedCuisine) =>
      window.analytics.sendEvent(
        CATEGORY_CITYWIDE_SEARCH,
        ACTION_CUISINE_FILTER_APPLIED,
        selectedCuisine
      )
    );
    // todo [BRM 2020/10/24] determine how to track multiple applied filters and unapplying a filter?
  };

  return { cuisineFiltersEnabled, sendCuisineGAEvents };
};
